'use client';

import { forwardRef, useContext, useId } from 'react';

import { css, cx } from '@/styled-system/css';

import { useIsomorphicLayoutEffect } from '../../hooks/use-isomorphic-layout-effect';
import { DropdownRootContext } from './context/dropdown-root.context';
import { dropdownBodyStyles } from './styles/dropdown-body.styles';
import type { DropdownBodyPropsInterface } from './types/dropdown-body.types';

/**
 * @since 10.0.0
 */
export const DropdownBody = forwardRef<HTMLDivElement, DropdownBodyPropsInterface>(
  (props: DropdownBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { dropdown } = useContext(DropdownRootContext);
    const id = useId();
    const styles = css(dropdownBodyStyles, cssProp);

    useIsomorphicLayoutEffect(() => {
      dropdown.setDescriptionId(id);
      return () => dropdown.setDescriptionId(undefined);
    }, [id, dropdown.setDescriptionId]);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Body"
        id={id}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DropdownBody.displayName = 'Dropdown.Body';
